module.exports = __webpack_public_path__ + "img/Number=66.0d5ba6ab.png";